// extracted by mini-css-extract-plugin
module.exports = {"hyperlink":"Hyperlink_hyperlink__gYCeD"};